import { protectedRoute } from "../config/api.config";

export function getMyDirectsAPI({ queryKey }) {
  const [, data] = queryKey;
  return protectedRoute.get('/direct/get-my-directs', { params: data });
}

// export function createNewDirectAPI(payload) {
//   return protectedRoute.post('/direct/create', payload);
// }